import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    token: "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJkdGZpcm1hZG1pbiIsImV4cCI6MTY3MDgzNjk3MiwiaWF0IjoxNjcwODE4OTcyfQ.innFC2uobUwPv84P8mAmc6jRf9gRAQjkNpbMYMZSysaxQpSn_si3srC_Qp3F0KyYSKbwrwtls1pqbT1K8WS8iw"
}

export const tokenSlice = createSlice({
    name: "token",
    initialState: {value: initialState},
    reducers: {
        saveToken: (state, action) => {
            state.value = action.payload;
        },
        removeToken: (state) => {
            state.value = initialState;
        }
    }
})

export const {saveToken, removeToken} = tokenSlice.actions;

export default tokenSlice.reducer;